// fichier : mv-modal-quick.js


class MvQuickView {
  constructor() {
    this.modal = null;
    this.loadingEl = null;
    this.contentEl = null;
    this.init();
  }

  /**
   * Initialisation
   */
  init() {
    // Attacher les événements de clic sur tous les boutons quick-view
    this.attachButtonEvents();
  }

  /**
   * Attache les événements aux boutons quick-view
   */
  attachButtonEvents() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.quick-view-btn');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        
        const productHandle = btn.dataset.productHandle;
        if (productHandle) {
          this.openModal(productHandle);
        }
      }
    });
  }

  /**
   * Ouvre le modal et charge le produit
   * @param {string} productHandle - Le handle du produit
   */
  async openModal(productHandle) {
    // Récupérer les éléments du modal
    this.modal = document.getElementById('quick-view-modal');
    this.loadingEl = this.modal.querySelector('.quick-view-loading');
    this.contentEl = this.modal.querySelector('.quick-view-product-info');

    if (!this.modal) {
      console.error('Modal quick-view introuvable');
      return;
    }

    // Afficher le modal
    this.modal.style.display = 'flex';
    document.body.classList.add('quick-view-open');

    // Afficher le loading
    this.loadingEl.style.display = 'block';
    this.contentEl.style.display = 'none';
    this.contentEl.innerHTML = '';

    try {
      // Charger le produit via AJAX
      await this.loadProduct(productHandle);
    } catch (error) {
      console.error('Erreur lors du chargement du produit:', error);
      this.showError();
    }

    // Attacher les événements de fermeture
    this.attachCloseEvents();
  }

  /**
   * Charge le produit via AJAX
   * @param {string} productHandle - Le handle du produit
   */
  async loadProduct(productHandle) {
    // Construire l'URL avec la vue quick-view
    const url = `/products/${productHandle}?view=quick-view`;

    console.log('Chargement du produit:', url); // DEBUG

    // Faire la requête
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const html = await response.text();
    
    console.log('HTML reçu:', html.substring(0, 200)); // DEBUG - Afficher les 200 premiers caractères

    // Parser le HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    // Chercher le contenu de la quick-view
    const productContent = doc.querySelector('.quick-view-grid');

    console.log('Contenu trouvé:', productContent); // DEBUG

    if (productContent) {
      // Injecter le contenu
      this.contentEl.innerHTML = productContent.outerHTML;
      
      // Masquer le loading et afficher le contenu
      this.loadingEl.style.display = 'none';
      this.contentEl.style.display = 'block';
      // ✅ INITIALISER LES DROPDOWNS APRÈS INJECTION
if (typeof window.initQuickViewDropdowns === 'function') {
  window.initQuickViewDropdowns();
} else {
  console.error('❌ La fonction initQuickViewDropdowns n\'est pas définie');
}
    } else {
      // Si .quick-view-grid n'est pas trouvé, afficher tout le HTML retourné pour debug
      console.error('Sélecteur .quick-view-grid introuvable dans:', doc.body.innerHTML);
      throw new Error('Contenu du produit introuvable - Vérifier que product.quick-view.liquid existe');
    }
  }

  /**
   * Affiche un message d'erreur
   */
  showError() {
    this.contentEl.innerHTML = `
      <div style="text-align: center; padding: 40px;">
        <p style="color: #e74c3c; font-size: 16px; margin-bottom: 10px;">
          Une erreur est survenue lors du chargement du produit.
        </p>
        <p style="color: #666; font-size: 14px;">
          Veuillez réessayer ou visiter la page produit directement.
        </p>
      </div>
    `;
    
    this.loadingEl.style.display = 'none';
    this.contentEl.style.display = 'block';
  }

  /**
   * Attache les événements de fermeture du modal
   */
  attachCloseEvents() {
    const closeBtn = this.modal.querySelector('.quick-view-close');
    const overlay = this.modal.querySelector('.quick-view-overlay');

    // Fonction de fermeture
    const closeModal = () => {
      this.closeModal();
    };

    // Clic sur le bouton de fermeture
    if (closeBtn) {
      closeBtn.onclick = closeModal;
    }

    // Clic sur l'overlay
    if (overlay) {
      overlay.onclick = closeModal;
    }

    // Touche Escape
    const escapeHandler = (e) => {
      if (e.key === 'Escape') {
        closeModal();
        document.removeEventListener('keydown', escapeHandler);
      }
    };
    document.addEventListener('keydown', escapeHandler);
  }

  /**
   * Ferme le modal
   */
  closeModal() {
    if (this.modal) {
      this.modal.style.display = 'none';
      document.body.classList.remove('quick-view-open');
      
      // Nettoyer le contenu
      if (this.contentEl) {
        this.contentEl.innerHTML = '';
      }
    }
  }
}

// Initialiser la classe au chargement du DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MvQuickView();
  });
} else {
  new MvQuickView();
}

